/**
 * Generates CSS styles for fonts.
 * @param fonts - An array of font face definitions.
 * @returns A string containing CSS rules.
 */
function getFontStyles(fonts) {
    const fontFaceRules = [];
    fonts?.forEach((fontFace) => {
        fontFaceRules.push(`@font-face {
      font-family: '${fontFace.fontFamily}';
      font-style: ${fontFace.fontStyle};
      font-weight: ${fontFace.fontWeight};
      src: local('${fontFace.src.local}'), url('${fontFace.src.url}') format('${fontFace.src.format}');
      font-display: swap;
      unicode-range: U+0020-007F, U+0400-04FF, U+4E00-9FFF;
    }`);
    });
    fontFaceRules.push(`html {
    font-family: 'Picsart-Fonts', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, 'Arial', sans-serif;
  }`);
    return fontFaceRules.join('\n');
}
/**
 * Manages font styles and preloads for SSR and CSR.
 * - For SSR: Injects font styles into the provided HTML string.
 * - For CSR: Dynamically preloads fonts and provides a cleanup mechanism.
 *
 * @param fonts - An array of font face definitions.
 * @param ssrHtml - Optional HTML string for SSR.
 * @returns Modified HTML string for SSR or a cleanup function for CSR.
 */
function applyFontStyles(fonts, ssrHtml) {
    if (ssrHtml !== undefined) {
        const fontStyles = getFontStyles(fonts);
        return ssrHtml.replace('</head>', `<style>${fontStyles}</style></head>`);
    }
    if (typeof document !== 'undefined') {
        const addedLinks = [];
        const headElement = document.head;
        fonts?.forEach(({ src }) => {
            const linkElement = document.createElement('link');
            linkElement.rel = 'preload';
            linkElement.href = src.url;
            linkElement.as = 'font';
            linkElement.type = `font/${src.format}`;
            linkElement.crossOrigin = 'anonymous';
            headElement.appendChild(linkElement);
            addedLinks.push(linkElement);
        });
        return () => {
            addedLinks?.forEach(link => link.remove());
        };
    }
    return '';
}

export { applyFontStyles, getFontStyles };
